module.exports = __webpack_public_path__ + "static/media/file1.1efb07c2.svg";